<ckeditor [editor]="Editor" [formControl]="control" (ready)="onEditorReady($event)" [class.has-content]="control.value?.length > 0"></ckeditor>
<rnb-subscript-wrapper [hasError]="!control.valid && control.touched" [disabled]="disabled">
  <ng-content select="rds-control-hint" ngProjectAs="rds-control-hint"></ng-content>
  <ng-content select="rds-control-error" ngProjectAs="rds-control-error"></ng-content>
</rnb-subscript-wrapper>